import { type MCPServerInfo } from '../../types';

const TableauServer: MCPServerInfo = {
  serverId: 'TABLEAU',
  name: 'Tableau',
  slug: 'tableau',
  description:
    'Official Tableau MCP Server - Build and configure AI applications that integrate with Tableau Cloud and Server',
  source: {
    sourceType: 'REPOSITORY',
    type: 'OFFICIAL',
    repositoryUrl: 'mcp/tableau:latest',
    commitSha: 'latest',
    packageType: 'npm',
    packageName: '@tableau/mcp-server'
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [
      'tableauServer',
      'tableauSiteName',
      'tableauPatName',
      'tableauPatValue'
    ],
    properties: {
      tableauServer: {
        type: 'string',
        description: 'Tableau Server URL (e.g., https://my-tableau-server.com)',
        sensitive: false
      },
      tableauSiteName: {
        type: 'string',
        description:
          'Tableau Site Name (check your url for /site/YourSiteName)',
        sensitive: false
      },
      tableauPatName: {
        type: 'string',
        description: 'Personal Access Token Name',
        sensitive: false
      },
      tableauPatValue: {
        type: 'string',
        description: 'Personal Access Token Value',
        sensitive: true
      }
    }
  }
};

export default TableauServer;
